import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import graphqlClient from "@/GQLClient";
import {
  type EmployeeTitleInput,
  GetEmployeesTitleDocument,
  SaveEmployeeTitleDocument,
} from "@/graphql/generated-types";
import type { EmployeeTitleFragment } from "@/graphql";
import { useAuthStore } from "@/stores/authStore";

const getTitles = async () => {
  const response = await graphqlClient.query({
    query: GetEmployeesTitleDocument,
    variables: {},
  });

  if (response.data.institutions?.getEmployeeTitles) {
    return response.data.institutions
      .getEmployeeTitles as EmployeeTitleFragment[];
  }

  throw new SentryGraphQLError("employeesTitles.getTitles");
};

const save = async (title: EmployeeTitleInput) => {
  const authStore = useAuthStore();

  const response = await graphqlClient.mutate({
    mutation: SaveEmployeeTitleDocument,
    variables: {
      title: {
        ...title,
        institution: authStore.institutionId,
      },
    },
  });
  if (response.data?.institution?.saveEmployeeTitle?.success) {
    return response.data.institution.saveEmployeeTitle;
  }
  throw new SentryGraphQLError("employeesTitles.save");
};

const deleteItem = async (title: EmployeeTitleInput) => {
  // We should set the status FALSE to delete it
  title.status = false;
  // Now we can save it.
  return save(title);
};

export default {
  getTitles,
  save,
  deleteItem,
};
